import {SkinTheme, UIType} from "../@const";
import {GoodDayUserInterface} from "../ui";
import UI_Layout from "../../layout/ui-layout";
import GrayPalette_Teams from "./gray-palette-teams";
import UILeftTeams from "./menu/left";
import UITopTeams from "./top-panel/ui-top";
import PaletteProto from "../../../core/gd/skin/skin-palette/palette-proto";
import CommonPaletteTeams from "./common-palette-teams";
import NavigationPanel_Teams_User from "./navigation-panel/user";


export class UITeams extends GoodDayUserInterface {

    constructor() {
        super({
            type        : UIType.TEAMS
        })
    }

    // Navigation Panel

    get NavigationPanelUserComponent():any {
        return NavigationPanel_Teams_User
    }

    get navbarButtonSize() {
        return 68
    }

    get navigationPanelMainClass() {

        // let classes = "ui-navigation-teams left-nav"
        let classes = "ui-navigation teams-navigation"

        switch (gd.skin.layoutTheme) {
            case SkinTheme.DARK:
                classes += ' theme-dark'
                break

            case SkinTheme.LIGHT:
            default:
                classes += ' theme-light'
                break
        }

        return classes
    }

    get leftNavigationPanelSize(): number {
        return 68
    }

    //



    get layoutCSSClass():string {
        return "ui-layout left-nav"
    }

    get isMinimizeMenuAllowed() {
        return false;
    }

    get TopPanel():any {
        return UITopTeams
    }

    get UILeftClass() {
        return UILeftTeams
    }

    get uiLeftMenuThemeClass() {

        if (gd.skin.layoutTheme === 'dark') {
            return  "theme-dark"
        } else {
            return "theme-light"
        }
    }

    get LayoutClass() {
        return UI_Layout
    }

    get uiLeftTargetClassName() {
        return ".ui-left-teams"
    }

    get uiLeftPopoverClassName() {
        return "ui-menu-popover-teams"
    }


    get uiCenterLeftSpace(): number {
        return this.leftNavigationPanelSize + 5
    }

    get uiCenterLeftSideDifference(): number {
        // return this.leftNavigationPanelSize + 10
        return this.uiCenterLeftSpace + 6 // 5 is padding from right
    }

    get uiCenterMainClass() {
        return 'ui-center-teams'
    }

    get hasMenuSearch() {
        return false
    }

    getCommonPalette(theme: SkinTheme): PaletteProto {

        return new CommonPaletteTeams(theme)
    }

    getGrayPalette(theme: SkinTheme): PaletteProto {

        return new GrayPalette_Teams(theme)
    }

    get moreLabel(): string {
        return "More"
    }

}
